import * as lmsService from '../core/lms';
import * as actions from '../redux/constants';

export const setUserLmsId = (info) => async (dispatch) => {
  const user = await lmsService.setUserLmsId(info);
  if (!user) {
    // eslint-disable-next-line no-throw-literal
    throw { message: 'Error Occurred Setting User ID' };
  }

  dispatch({
    type: actions.PATCH_USER_LMS,
    payload: user,
  });

  // Renews the cookie to set the updated ID
  await lmsService.extendSession();
};
